import {
  QueryClient,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { fetchListFlowDetails } from '~/api/listFlow';
import { RailsDetail } from '~/typings/services/rails/item';
import { minutes30inMS } from '../../constants/times';

/**
 *
 * @param queryClient Should be the shared query client
 * @param categoryId
 */
export function prefetchListFlowDetails(
  queryClient: QueryClient,
  categoryId: number | string,
) {
  try {
    return queryClient.fetchQuery(
      ['list-flow-details', categoryId],
      () => fetchListFlowDetails(categoryId),
      {
        staleTime: minutes30inMS,
      },
    );
  } catch (e) {
    console.error('FAILED TO FETCH DETAILS');
  }
}

export function useListFlowDetails(
  categoryId?: number | string,
  options?: UseQueryOptions<RailsDetail[]>,
): UseQueryResult<RailsDetail[]> {
  return useQuery<RailsDetail[]>(
    ['list-flow-details', categoryId],
    () => fetchListFlowDetails(categoryId!),
    {
      enabled: !!categoryId,
      staleTime: minutes30inMS,
      ...options,
    },
  );
}
